import { api } from '@/api/axios';
export type GivingAccess = {
    enabled: boolean;
    currency: string | null;
    permissions: string[];
};
export type Setup = {
    sources: {
        id: string;
        name: string;
    }[];
    funds: {
        id: string;
        code: string;
        name: string;
    }[];
    donors: {
        display_name: string;
        id: string;
        kind: string;
        member_id: string | null;
        household_id: string | null;
    }[];
};
export type ImportRow = {
    row_number: number;
    duplicate_status?: string;
    values: Record<string, string>;
    errors: string[];
    disposition: string;
    reason: string | null;
};
export type Receipt = {
    batch_id: string;
    row_count: number;
    gross: string;
    returned: string;
    currency: string;
    coverage: string;
    hash: string;
    excluded_rows: number[];
    duplicates: number;
};
export type Preview = {
    id: string;
    version: number;
    status: string;
    coverage: string;
    rows: ImportRow[];
    totals: Record<string, string>;
    receipt: Receipt | null;
};
export type Contribution = {
    id: string;
    received_on: string;
    amount: string;
    currency: string;
    kind: string;
    donor_id: string;
    household_id: string | null;
    original_id?: string | null;
};
export type GivingReport = {start:string; end:string; currency:string; net:string; funds:{code:string; name:string; net:string}[]};
export function givingApi(churchId: string) {
    const root = `/api/churches/${churchId}/giving`;
    return {
        report: async (start: string, end: string) => (await api.get<GivingReport>(root + '/reports/funds', { params: { start, end } })).data,
        access: async () => (await api.get<GivingAccess>(root + '/access')).data,
        setup: async () => (await api.get<Setup>(root + '/setup')).data,
        configure: async (enabled: boolean, currency: string) => (await api.patch(root + '/settings', { enabled, currency })).data,
        source: async (name: string) => (await api.post(root + '/sources', { name })).data,
        fund: async (code: string, name: string) => (await api.post(root + '/funds', { code, name })).data,
        donor: async (kind: string, member_id: string | null, household_id: string | null) => (await api.post(root + '/donors', { kind, member_id, household_id })).data,
        upload: async (sourceId: string, file: File, mappings: Record<string, string>) => {
            const form = new FormData();
            form.append('source_id', sourceId);
            form.append('file', file);
            form.append('mappings', JSON.stringify(mappings));
            return (await api.post<Preview>(root + '/imports', form, { headers: { 'Content-Type': 'multipart/form-data' } })).data;
        },
        resolve: async (batch: Preview, rows: unknown[], coverage: string, coverage_start: string | null, coverage_end: string | null) => (await api.patch<Preview>(root + `/imports/${batch.id}/resolutions`, { expected_version: batch.version, rows, coverage, coverage_start, coverage_end })).data,
        preview: async (id: string) => (await api.get<Preview>(root + `/imports/${id}`)).data,
        commit: async (batch: Preview) => (await api.post<Receipt>(root + `/imports/${batch.id}/commit`, { expected_version: batch.version })).data,
        history: async (offset: number) => (await api.get<Contribution[]>(root + '/contributions', { params: { offset, limit: 25 } })).data,
    };
}
